import T from 'prop-types'
import React, { useEffect } from 'react'
import Container from 'components/Container'
import Button from 'components/Button'
import Editorial from 'components/Editorial'
import useSession from 'hooks/useSession'
import { removeItem } from 'lib/storage'
import Header from 'apps/booking/components/Header'

export default function RejectionPage({
  match: {
    params: { orgUnit },
  },
}) {
  const { clearSession } = useSession()

  // Flush the session storage to prevent user from going back and getting confused
  useEffect(() => {
    removeItem('bookingState')
  }, [])

  return (
    <>
      <Header seoTitle="Du har gitt beskjed" />

      <Container size="wizard" style={{ paddingBottom: '3rem' }}>
        <h1>Du har gitt beskjed om at du ikke ønsker koronavaksine.</h1>
        <Editorial>
          <p>
            For å holde oversikt over fremgangen i vaksinasjonsprogrammet, er det svært nyttig å
            vite at du ikke ønsker en vaksine mot covid-19.
          </p>
          <p>
            Ditt svar er nå registrert, og du vil ikke bli kontaktet aktivt igjen angående vaksine.
          </p>
          <p>Du kan selvsagt ombestemme deg, men må da selv ta kontakt for å si fra.</p>
          <p>Takk for at du sa fra.</p>
        </Editorial>
        <Button onClick={() => clearSession(`/${orgUnit}`)} primary>
          Avslutt og logg ut
        </Button>
      </Container>
    </>
  )
}

RejectionPage.propTypes = {
  match: T.shape({
    params: T.shape({
      orgUnit: T.string.isRequired,
    }).isRequired,
  }).isRequired,
}
